[
  { "id": "manicure", "cat": "Uñas", "name": "Manicure tradicional", "price": 12000, "dur": 45 },
  { "id": "semi", "cat": "Uñas", "name": "Esmaltado semipermanente", "price": 18900, "dur": 75 },
  { "id": "kapping", "cat": "Uñas", "name": "Kapping / Soft gel", "price": 28000, "dur": 90 },
  { "id": "polygel", "cat": "Uñas", "name": "Polygel / Acrílico", "price": 38000, "dur": 120 },
  { "id": "nailart", "cat": "Uñas", "name": "Nail Art (por uña)", "price": 1000, "dur": 10, "note": "desde" },
  { "id": "pedi", "cat": "Uñas", "name": "Pedicure Spa", "price": 20000, "dur": 60 },
  { "id": "limpieza", "cat": "Skin Care", "name": "Limpieza facial profunda", "price": 30000, "dur": 60 },
  { "id": "hidrata", "cat": "Skin Care", "name": "Hidratación facial", "price": 25000, "dur": 45 },
  { "id": "pestanas", "cat": "Pestañas", "name": "Pestañas pelo a pelo", "price": 35000, "dur": 90 },
  { "id": "laminado", "cat": "Pestañas", "name": "Laminado de cejas", "price": 18000, "dur": 45 },
  { "id": "cejas", "cat": "Pestañas", "name": "Perfilado de cejas", "price": 10000, "dur": 20 }
]
